import { h, svgUse } from '../../../utils/dom.js';
import { t } from '../../../i18n/index.js';

export function SearchBox() {
  const input = h('input', { type: 'text', placeholder: t('searchPh') });
  const el = h('div', { class: 'search-box', id: 'searchBox' },
    svgUse('ic-search'),
    input,
  );
  return {
    el,
    toggle() {
      const open = el.classList.toggle('open');
      if (open) input.focus();
    },
  };
}
